export const options = {
	enableCrash: false,
	logStuff: false,
}

window.__OPENREPLAY_DEV_TOOLS = options;